module.exports = __webpack_public_path__ + "media/images/themes/spring_bohemian/ring_semi_transparent1-ab6b791108040239965ba4cfb91711ef.png";